import { Directive } from '@angular/core';
@Directive({
  selector: '[fUserMenuContainer]'
})
export class UserMenuContainerDirective {}
